
import { createContext, useState, useEffect } from "react"
import axios from 'axios'
import { ToastContainer, toast,Slide, Zoom, Flip, Bounce,cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";



export const UserContext = createContext();

export const UserProvider = ({children}) => {

const [userInfo, setUserinfo] = useState({});
const [empid, setEmpid] = useState('');
const [reset, setReset] = useState(false);
const [spin, setSpin] = useState(false)
const [userName, setUserName] = useState('')
const [employees, setEmployees] = useState([])
const [customers, setCustomers] = useState([])
const [salesreps, setSalesreps] = useState([])
const [uploadercustomers, setUploadercustomers] = useState([])
const [csrreps, setCsrreps] = useState([])
const [auth, setAuth] = useState(0)
const nav = useNavigate()

const apiURL = 'https://plsuploader-7381434a72f8.herokuapp.com'
//const apiURL = 'http://localhost:5003'

useEffect(() => {

  const getuser = async() => {
let h = {id:sessionStorage.getItem('user')}
//console.log(h)
const resp = await axios.post(`${apiURL}/users/getuser`,h)
//console.log(resp)
if(resp.data.status === 200){
 setUserinfo(resp.data?.message[0])
}
  }

  const getuploadercustomers = async() => {
       const res = await axios.get(`${apiURL}/users/users/all`)

       setUploadercustomers(res.data.message)
  }

  const getcustomers = async() => {
       const res = await axios.get('https://highgroundapi.herokuapp.com/customers/all')
       setCustomers(res.data)
  }

   const getSalesRep = async() => {
       const res = await axios.get('https://highgroundapi.herokuapp.com/employee/sales')
       //console.log(res.data)
       setSalesreps(res.data)
  }
    const getCsrRep = async() => {
       const res = await axios.get('https://highgroundapi.herokuapp.com/employee/csr')
       //console.log(res.data)
       setCsrreps(res.data)
  }
  getCsrRep()
  getSalesRep()
getuser()
getcustomers()
getuploadercustomers()
},[])


const logout= () => {
  sessionStorage.removeItem('user')
  nav('/',{replace: true})
}


const login = async (email, pass,nav, from = '/dashboard') => {
  console.log('Login params:', { email, from, navType: typeof nav });
  let g = {
    email,
    pass,
  };
await axios.post(`${apiURL}/users/login`,g)
//await axios.post(`${apiURL}/users/login`,g)
.then(res => {
console.log(res.data)
  if(res.data.status === 200){
  //console.log(res.data)
    if(res.data.message === 'firsttime'){
      //console.log('true')
return nav(`/passreset/${res.data.id}`,{replace: true})
    }
if(res.data.message.active === 'true'){
    sessionStorage.setItem('user',res.data.message._id)
  setUserinfo(res.data.message)
 setAuth(res.data.message?.level)
 console.log(from)
nav(from, { replace: true });
  }else{
  setUserinfo({})
  nav('/',{replace: true}) 
  toast.warning('Account Inactive at the moment. Awaiting Approval.')
}
}else{
    toast.error(res.data.message)
  }
})
  .catch(err =>console.log(err)) 
  
}

//console.log(userInfo)
//console.log(auth)

const value={
auth,
  apiURL,
  logout,
  setUserinfo,
  userInfo,
  login,
  customers,
  salesreps,
  csrreps,
  uploadercustomers,
}


  return (
    <UserContext.Provider value={value}>
         <ToastContainer position="top-center" theme="dark"  autoClose="2000" hideProgressBar={true} transition={Flip} />
        {children}
    </UserContext.Provider>
  )
}

export default UserContext 

